import { makeJsonApiRequest } from '@base/axios.ts'

export default {
  saveViewCustomization: function (viewId, formData) {
    const url = `/api/v2/views/${viewId}/customizations`
    const data = {
      data: {
        type: 'customizations',
        attributes: {
          customizable_type: 'View',
          customizable_id: viewId,
          values: formData,
        },
      },
    }
    return makeJsonApiRequest({
      url,
      method: 'post',
      data,
      requestId: `save-view-customization-${viewId}`,
    })
  },
}
